<ngx-spinner bdColor="rgba(0,0,0,0)" size="medium" color="#0078d4" type="ball-spin-clockwise"></ngx-spinner>

<div class="ms-login-wrapper">
  <!-- Top Right Floating Theme Switcher -->
  <div class="ms-login-theme-switcher dropdown">
    <button type="button" class="ms-theme-dots-btn" id="loginThemeDropdown" data-toggle="dropdown" title="Select Application Theme">
      <i class="fas fa-palette margin-right-6px"></i>
      <span>Theme</span>
      <i class="fas fa-ellipsis-v margin-left-6px"></i>
    </button>
    <div class="dropdown-menu dropdown-menu-right ms-theme-dropdown-menu p-0 shadow-lg" aria-labelledby="loginThemeDropdown">
      <div class="ms-theme-popup-header">
        <div class="d-flex align-items-center justify-content-between">
          <span class="font-weight-bold font-size-13px text-dark">
            <i class="fas fa-palette text-primary margin-right-6px"></i> Application Themes
          </span>
          <span class="badge badge-pill badge-primary font-size-10px">5 Themes</span>
        </div>
      </div>
      <div class="ms-theme-popup-body">
        <div class="ms-theme-option-item" *ngFor="let t of themes" (click)="selectTheme(t.id)" [class.active]="currentTheme === t.id">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="ms-theme-color-badge" [style.background]="t.previewGradient"></span>
              <div class="margin-left-10px">
                <div class="font-weight-bold font-size-12px text-dark">{{t.name}}</div>
                <div class="font-size-10px text-muted">{{t.description}}</div>
              </div>
            </div>
            <i class="fas fa-check-circle text-primary font-size-14px" *ngIf="currentTheme === t.id"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Grand Executive Login Card -->
  <div class="ms-login-card-container">
    <form class="ms-login-form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="ms-login-card">
        
        <!-- Header & Logo -->
        <div class="ms-login-card-header">
          <div class="ms-login-logo-box">
            <img [src]='logo' [style.width.px]="logowidth || 160" [style.height.px]="logoheight || 54" onError="this.src='Navlogo.png';" alt="Healins Life Logo">
          </div>
          <h3 class="ms-login-title">Sign In</h3>
          <p class="ms-login-subtitle">Enterprise Healthcare Management System</p>
        </div>

        <!-- Form Body -->
        <div class="ms-login-card-body">
          <!-- Username Input -->
          <div class="ms-login-field-group">
            <label class="ms-login-label">Email ID / User Name <span class="text-danger">*</span></label>
            <div class="ms-login-input-wrapper">
              <i class="fas fa-user ms-login-field-icon"></i>
              <input type="text" class="ms-login-input" name="CurrentLoginRequest.UserName" id="CurrentLoginRequest.UserName"
                     [(ngModel)]="CurrentLoginRequest.UserName" placeholder="Enter your User Name" required maxlength="50" #UserName="ngModel">
            </div>
            <small class="text-danger margin-top-4px d-block font-size-11px" *ngIf="(!UserName.valid && (UserName.dirty || UserName.touched))">User Name is required</small>
          </div>

          <!-- Password Input -->
          <div class="ms-login-field-group">
            <label class="ms-login-label">Password <span class="text-danger">*</span></label>
            <div class="ms-login-input-wrapper">
              <i class="fas fa-lock ms-login-field-icon"></i>
              <input type="password" class="ms-login-input" name="CurrentLoginRequest.Password" id="CurrentLoginRequest.Password"
                     [(ngModel)]="CurrentLoginRequest.Password" placeholder="Enter your Password" required #Password="ngModel">
            </div>
            <small class="text-danger margin-top-4px d-block font-size-11px" *ngIf="(!Password.valid && (Password.dirty || Password.touched))">Password is required</small>
          </div>
        </div>

        <!-- Card Footer & Submit Button -->
        <div class="ms-login-card-footer">
          <button type="submit" [disabled]="!f.valid || isRequesting" class="ms-login-submit-btn">
            <span *ngIf="!isRequesting">Sign In <i class="fas fa-arrow-right margin-left-6px"></i></span>
            <span *ngIf="isRequesting"><i class="fas fa-spinner fa-spin margin-right-6px"></i> Signing In...</span>
          </button>
        </div>

      </div>
    </form>
  </div>
</div>


